/*
 * @Description:
 * @Author: suzyli
 * @Date: 2020-03-18 15:11:16
 * @LastEditTime: 2021-05-17 16:52:25
 */

/* global log  */
import { isFunction } from '../../common/base';
import platform from '../../common/platform';
import wxShare from './wxShare';
import qqShare from './qqShare';
import qqBrowserShare from './qqBrowserShare';
import MsdkShare from './msdkShare';
import arkShare from './arkShare';
import dyPublish from './dyPublish';

if (/MSDK\/5/i.test(window.navigator.userAgent)) {
  var setupWebViewJavascriptBridge = function setupWebViewJavascriptBridge(callback) {
    if (window.WebViewJavascriptBridge) {
      return callback(window.WebViewJavascriptBridge);
    }

    if (window.WVJBCallbacks) {
      return window.WVJBCallbacks.push(callback);
    }

    window.WVJBCallbacks = [callback];
    var WVJBIframe = document.createElement('iframe');
    WVJBIframe.style.display = 'none';
    WVJBIframe.src = 'https://__bridge_loaded__';
    document.documentElement.appendChild(WVJBIframe);
    setTimeout(function () {
      document.documentElement.removeChild(WVJBIframe);
    }, 0);
  };

  setupWebViewJavascriptBridge(function (bridge) {
    window.msdkiOSHandler = bridge.callHandler;
    bridge.registerHandler('MSDKJSHandler', function (data) {
      log('ObjC called MSDKJSHandler with', data);
    });
  });
}

var initShareAll = function initShareAll(opts) {
  if (platform.isWxApp()) {
    // 实现微信分享
    // 微信客户初始化成功后，返回wx对象
    wxShare.init({
      sAppId: opts.wx_appid,
      // 这里请填上你的微信公众号的APPID，形如：wxfeb5a65212da517c
      debug: opts.debug != undefined
    }, function () {
      var shareData = {
        title: opts.title,
        // 分享标题，默认为活动页面标题（可手动调整）
        desc: opts.desc,
        // 分享活动简介，默认为活动页面标题（可手动调整）
        link: opts.link,
        // 分享链接，分享后朋友看到的链接地址，默认为活动的URL地址（可手动调整）
        imgUrl: opts.imgUrl,
        // 分享后朋友看到的图标（可手动调整）
        trigger: opts.WXtrigger,
        success: opts.WXsuccess,
        cancel: opts.WXcancel,
        fail: opts.WXfail
      };
      console.log(shareData); // 为发送给好友、分享到朋友圈、分享到QQ、分享到微博同时绑定分享事件

      wxShare.shareAll(shareData);
    });
  } else if (platform.isQQApp()) {
    var shareObj = {
      appid: opts.wx_appid,
      title: opts.title,
      // 分享标题，默认为活动页面标题（可手动调整）
      desc: opts.desc,
      // 分享活动简介
      link: opts.link,
      // 分享链接
      imageUrl: opts.imgUrl,
      // 分享后朋友看到的图标
      QQcallback: opts.QQcallback,
      // qq成功、失败、或取消的回调
      QQtrigger: opts.QQtrigger // qq触发事件的回调

    };
    console.log(shareObj);
    qqShare(shareObj);
  } else if (platform.isMQQBrowser()) {
    var _shareObj = {
      title: opts.title,
      // 分享标题，默认为活动页面标题（可手动调整）
      desc: opts.desc,
      // 分享活动简介
      share_url: opts.link,
      // 分享链接
      image_url: opts.imgUrl,
      // 分享后朋友看到的图标
      qqBrowserCallback: function qqBrowserCallback(data) {
        // data.code ==1 表示能分享
        // data.code ==-1 表示不能分享
        // data.code == 0 表示未知
        if (isFunction(opts.qqBrowserCallback)) {
          opts.qqBrowserCallback(data);
        }
      }
    };
    qqBrowserShare(_shareObj);
  }
};

var msdkShare = function msdkShare(opts) {
  if (/msdk/i.test(window.navigator.userAgent)) {
    var shareObj = {
      msdkMethod: opts.msdkMethod,
      scene: opts.scene,
      title: opts.title,
      desc: opts.desc,
      url: opts.link || opts.url,
      withPop: opts.withPop,
      paramsV5: opts.paramsV5,
      imgUrl: opts.imgUrl
    };
    MsdkShare.share(shareObj);
  }
};

export default {
  initShareAll: initShareAll,
  msdkShare: msdkShare,
  arkShare: arkShare,
  dyPublish: dyPublish
};